import axiosClient from './axiosClient';
import { TicketSeverityModel } from '../Models/ticketSeverityModel';

const ticketSeverityService = {
  getAll: () => {
    return axiosClient.get('/TicketSeverity')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketSeverity returned 404. Falling back to GET /ticket-severities...");
          return axiosClient.get('/ticket-severities');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketSeverityModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (id) => {
    return axiosClient.get(`/TicketSeverity/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketSeverity/${id} returned 404. Falling back to GET /ticket-severities/${id}...`);
          return axiosClient.get(`/ticket-severities/${id}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketSeverityModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = TicketSeverityModel.toBackend(payload);
    body.severityId = 0;

    return axiosClient.post('/TicketSeverity', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketSeverity returned 404. Falling back to POST /ticket-severities...");
          return axiosClient.post('/ticket-severities', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketSeverityModel.toFrontend(raw),
        };
      });
  },

  update: (id, payload) => {
    const body = TicketSeverityModel.toBackend({ ...payload, severityID: id });

    return axiosClient.put('/TicketSeverity', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /TicketSeverity returned 404. Falling back to PUT /ticket-severities...");
          return axiosClient.put('/ticket-severities', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketSeverityModel.toFrontend(raw),
        };
      });
  },

  remove: (id) => {
    return axiosClient.delete(`/TicketSeverity/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketSeverity/${id} returned 404. Falling back to DELETE /ticket-severities/${id}...`);
          return axiosClient.delete(`/ticket-severities/${id}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketSeverityService;
